import { format } from "date-fns";
import background from "../../assets/demyst_meta_image.png";
import React from "react";

export default React.forwardRef(({ title, url, featured_image, date, description, more }, ref) => {
  return (
    <div ref={ref} key={title} className="highlight-card">
      <a href={url}>
        <div
          className="highlight-card-image"
          style={{
            backgroundImage: `url(${featured_image || background})`,
          }}
        />
        <div className="highlight-card-cover" />
        <section className="highlight-card-textarea">
          <h3 className="highlight-card-title">{title}</h3>
          <p className="highlight-card-description">{description}</p>
          <p className="highlight-card-date">{format(new Date(date), "LLLL dd, yyyy")}</p>
          <p className="highlight-card-more">{more}</p>
        </section>
      </a>
    </div>
  );
});
